module.exports = __webpack_public_path__ + "static/quizlet-b1efefe3b9494fb078d7e55450a56490.png";